import { gql, useMutation } from '@apollo/client'

const mutation = gql`
  mutation createSavedOffer($offerId: String!) {
    createSavedOffer(offerId: $offerId) {
      success
      message
    }
  }
`

export interface CreateSavedOfferInput {
  offerId: string
}

export interface CreateSavedOfferOutput {
  createSavedOffer: {
    success: boolean
    message: string
  }
}

export const useCreateSavedOffer = () =>
  useMutation<CreateSavedOfferOutput, CreateSavedOfferInput>(mutation)
